import React, { useMemo } from "react";

const ITEM_TYPE_LABELS = {
  ANF: "Adult Non-Fiction",
  AF: "Adult Fiction",
  CNF: "Children's Non-Fiction",
  CF: "Children's Fiction",
  TNF: "Teen Non-Fiction",
  TF: "Teen Fiction",
  REF: "Reference",
};

function BranchPanel({ branch, onSearchCollection }) {
  const {
    branch_name,
    council,
    total_books,
    item_type_breakdown = {},
    top_rated_books = [],
  } = branch;

  const sortedBreakdown = useMemo(() => {
    const entries = Object.entries(item_type_breakdown).sort(
      ([, a], [, b]) => b - a,
    );
    const total = entries.reduce((sum, [, v]) => sum + v, 0) || 1;
    return { entries, total };
  }, [item_type_breakdown]);

  return (
    <>
      <div className="panel-branch-header">
        <div className="dialog-icon">📚</div>
        <div>
          <h2 className="dialog-title">{branch_name}</h2>
          <p className="dialog-council">{council}</p>
        </div>
      </div>

      <div className="dialog-stats">
        <div className="stat-card">
          <span className="stat-number">
            {Number(total_books).toLocaleString()}
          </span>
          <span className="stat-label">Unloaned Books</span>
        </div>
      </div>

      {sortedBreakdown.entries.length > 0 && (
        <div className="dialog-section">
          <h3>Unloaned Collection Breakdown</h3>
          <div className="breakdown-grid">
            {sortedBreakdown.entries.map(([type, count]) => (
              <div key={type} className="breakdown-item">
                <span className="breakdown-type">
                  {ITEM_TYPE_LABELS[type] || type}
                </span>
                <div className="breakdown-bar-wrapper">
                  <div
                    className="breakdown-bar"
                    style={{ width: `${(count / sortedBreakdown.total) * 100}%` }}
                  />
                </div>
                <span className="breakdown-count">
                  {Number(count).toLocaleString()}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      {top_rated_books.length > 0 && (
        <div className="dialog-section">
          <h3>Top Books by OpenLibrary Rating</h3>
          <div className="books-list">
            {top_rated_books.slice(0, 5).map((book, i) => (
              <div key={i} className="book-item">
                <div className="book-rank">#{i + 1}</div>
                <div className="book-info">
                  <p className="book-title">
                    {book.isbn13 ? (
                      <a
                        href={`https://openlibrary.org/isbn/${book.isbn13}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {book.title}
                      </a>
                    ) : (
                      book.title
                    )}
                  </p>
                  <p className="book-author">{book.author}</p>
                  <div className="book-meta">
                    {book.rating != null && (
                      <span className="book-rating">
                        ★ {Number(book.rating).toFixed(1)}
                      </span>
                    )}
                    {book.genre && (
                      <span className="book-genre">{book.genre}</span>
                    )}
                    {book.year_published && (
                      <span className="book-year">{book.year_published}</span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {top_rated_books.length === 0 && (
        <p
          style={{
            fontSize: 13,
            color: "var(--text-muted)",
            fontStyle: "italic",
          }}
        >
          No rating data available for this branch.
        </p>
      )}

      <button className="search-collection-btn" onClick={onSearchCollection}>
        Search this collection
      </button>
    </>
  );
}

export default BranchPanel;
